<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">个人账单明细</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>账单管理</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/bill/personalbill' }">个人账单</el-breadcrumb-item>
                            <el-breadcrumb-item>个人账单明细</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="order_number" align="center" label="订单编号" min-width="230">
                            </el-table-column>
                            <el-table-column prop="sub_order_number" align="center" label="子单编号" min-width="250">
                            </el-table-column>
                            <el-table-column prop="mode_name" align="center" label="下单类型" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'tag-span tag-'+scope.row.order_mode">{{scope.row.mode_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desk_name" align="center" label="下单店铺/下单店铺" min-width="200">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desk_number" align="center" label="下单店铺编号" min-width="160">
                            </el-table-column>
                            <!-- <el-table-column prop="c_time" sortable="custom" align="center" label="下单时间" min-width="160">
                             </el-table-column>-->
                            <el-table-column prop="appointment_time" align="center" label="预定时间" min-width="140">
                                <template slot-scope="scope">
                                    <span>{{scope.row.appointment_time}} 预定</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="product_count" align="center" label="商品数量" min-width="120">
                            </el-table-column>
                            <el-table-column prop="paid_amount" align="center" label="订单总价" min-width="160">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <!--<el-table-column prop="operating" align="center" label="操作" min-width="80" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row.items)">商品详情</el-button>
                                </template>
                            </el-table-column>-->
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
                <el-dialog class="dialog-export activity-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible" width="800px" :close-on-click-modal="false">
                    <el-table ref="multipleTable" :data="dlg_goods.table_data.list" v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark" style="width: 100%;text-align: center;">
                        <el-table-column prop="product_name" align="center" label="商品名称" min-width="180">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_name"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_intro" align="center" label="商品简介" min-width="200">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_intro"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_count" align="center" label="商品数量" min-width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.product_count}}{{scope.row.product_unit}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sale_total_amount" align="center" label="商品总价" min-width="120">
                        </el-table-column>
                        <el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
                            <template slot-scope="scope">
                                <img class="cursor" :src="baseUrl + scope.row.product_image_url_s" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.product_image_url;dlg_preview.visible = true;" title="点击查看" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-dialog>
                <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
                    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                baseUrl:this.$client.IMG_URL,
                body_loading:false,
                is_refresh: true,
                form_search:{
                    lately_day:this.$route.query.lately_day == undefined? -1 : this.$route.query.lately_day,
                    user_number:this.$route.query.user_number == undefined? '' : this.$route.query.user_number,
                    start_appointment_date:this.$route.query.start_date == undefined? null : this.$route.query.start_date,
                    end_appointment_date:this.$route.query.end_date == undefined? null : this.$route.query.end_date,
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_goods:{
                    title:'',
                    visible:false,
                    table_data:{
                        loading: false,
                        list:[]
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '个人账单明细';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                this.$client.get('/adminapi/ordersub/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            goodsDetail(data){
                this.dlg_goods.visible = true;
                this.dlg_goods.table_data.list = data;
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>
    .status-2{
        color: #9a9a9a;
    }
    .status-1{
        color: #F31A5C;
    }
    .status-0{
        color: #F27918;
    }
    .status-3{
        color: #0C67F0;
    }
    .status-9{
        color: #04B365;
    }
    .status-10{
        color: #666;
    }
</style>